/*
  PASPAS KURALI: "Ortala" yerleşiminde eserin kağıt üstünde ne kadar yer
  kapladığını belirleyen tek yer.

  Bu dosya bilerek tek bir işlevden ibaret. Kural dört yerde çiziliyor:
  duvar tasarımcısının ekran çizimi, duvar tasarımcısının paylaşım tuvali,
  ürün sayfasının önizlemesi ve kart çerçevesi (koleksiyon / istek listesi).
  Hepsi bu işlevi (veya --ala-paspas-olcek'i) okur, böylece kural
  değişeceği zaman yalnızca burası düzenlenir ve yüzeyler birlikte değişir.

  Bugünkü kural (yüzde içeri): stüdyo PSD'sinden ölçüldü (dikey altlık.psd,
  2000x2800 @300dpi; kılavuzlar 240/1764 px). Eski sabit OLCEK = 0.762 idi:
  eser kağıdın her iki boyutunun yüzde 76,2'si; her kenardan yüzde 11,9
  içeri. 21 cm kısa kenarda bu ~2,5 cm boşluk verir.

  Önizleme: KENAR_CM = 2 (eski hedef 2.5). Aynı yüzde kuralı
  21 cm referansla türetilir, çizim anında okunur, ürüne yazılmaz.
  Geri almak için KENAR_CM'i 2.5 yapın (OLCEK yeniden 0.762 olur).

  Eşit genişliğe geçilecek olursa yalnızca eserKutusu gövdesi değişir.
  Kağıdın paspasa ayrılan alanı aynı kalsın isteniyorsa kenar payı b,
  (G - 2b)(Y - 2b) = 0,762^2 x G x Y denkleminin küçük kökü olur.
*/
(() => {
  const KENAR_CM = 2; // eski: 2.5 → OLCEK 0.762
  const REFERANS_KISA_KENAR_CM = 21;
  const OLCEK = 1 - 2 * (KENAR_CM / REFERANS_KISA_KENAR_CM);
  /* Ortala paspas / mektup kutusu: eser ile çerçeve-kağıt kenarı arası. */
  const KAGIT_RENK = '#f4f1ea';

  const olcekYuzde = `${(OLCEK * 100).toFixed(6)}%`;
  if (document.documentElement) {
    document.documentElement.style.setProperty('--ala-paspas-olcek', olcekYuzde);
    document.documentElement.style.setProperty('--ala-paspas-renk', KAGIT_RENK);
  }

  window.AlaPaspas = {
    olcek: OLCEK,
    kenarCm: KENAR_CM,
    kagitRenk: KAGIT_RENK,

    /*
      Kağıt ölçüsünü alır, eserin sığacağı kutuyu döndürür. Birim önemsiz:
      piksel verilirse piksel, santim verilirse santim döner. Eser bu kutuya
      oranını koruyarak yerleşir (object-fit: contain ile aynı davranış),
      artan yer kağıdın paspas rengi (kagitRenk) olarak kalır.
    */
    eserKutusu(kagitG, kagitY) {
      return { g: kagitG * OLCEK, y: kagitY * OLCEK };
    },

    /*
      Boyut seçeneğinin değerinden baskının en/boy oranını çıkarır:
      "50x70" -> 0,714. Çözülemezse null döner; çağıran taraf o zaman kağıdı
      baskı ölçüsüne göre çizemeyeceğini bilir ve eserin kendi oranına düşer.
      Ayırıcı olarak x, X ve * kabul edilir, ondalık ayracı nokta ya da virgül.
    */
    baskiOrani(deger) {
      const m = String(deger == null ? '' : deger)
        .trim()
        .match(/^(\d+(?:[.,]\d+)?)\s*[xX*]\s*(\d+(?:[.,]\d+)?)$/);
      if (!m) return null;
      const g = parseFloat(m[1].replace(',', '.'));
      const y = parseFloat(m[2].replace(',', '.'));
      if (!g || !y) return null;
      return g / y;
    },

    /*
      Kağıt geometrisi de burada duruyor, kuralın yanında: iki yüzey de aynı
      işlevi çağırdığı için kağıdın neye göre çizildiği bir daha ayrışamaz.

      Verilen alana sığan, baskı oranında en büyük dikdörtgeni döndürür ve
      alanın ortasına yerleştirir. Duvar tasarımcısında poster kutusu zaten
      baskı ölçüsünden üretiliyor; ürün sayfası da bu işlevle aynı kağıda
      ulaşır. Eser kağıda sonradan yerleşir: Ortala'da eserKutusu içine
      sığarak, Tam Oturt'ta kağıdı tamamen kaplayarak.
    */
    kagitKutusu(alanX, alanY, alanG, alanYuk, baskiOran) {
      let g = alanG;
      let y = alanG / baskiOran;
      if (y > alanYuk) {
        y = alanYuk;
        g = alanYuk * baskiOran;
      }
      return {
        x: alanX + (alanG - g) / 2,
        y: alanY + (alanYuk - y) / 2,
        g,
        yuk: y,
      };
    },

    /*
      KIRPMA HİZASI: ORTA. Açık bir varsayım, sessiz bir yan etki değil.

      Tam Oturt'ta eser kağıdı kapladığı için uzun eksenden kesilir ve kesme
      iki kenardan eşit yapılır. Portrelerde ve figürlü eserlerde üstten
      ağırlıklı bir hizalama (yukarıdan az, aşağıdan çok kesmek) genellikle
      daha iyi durur; baş ve yüz güvende kalır. Yine de orta seçildi, çünkü
      önizlemenin işi baskıyı güzelleştirmek değil ne basılacağını göstermek
      ve üretimde kesme ortadan yapılıyor. Üretim tarafı üstten ağırlıklıya
      geçerse burası ve kagitKutusu'nun çağrıldığı iki yer değişir.

      Kayıp ölçümünde hiza fark etmez: hangi kenardan kesilirse kesilsin
      kesilen toplam oran aynıdır.
    */
    kirpmaHizasi: 'orta',

    /*
      Tam Oturt'ta eserin uzun ekseninden kesilen oran. 0,258 dönerse eserin
      genişliğinin (ya da yüksekliğinin) yüzde 25,8'i basılmıyor demektir.
    */
    kirpmaKaybi(eserOran, baskiOran) {
      if (!eserOran || !baskiOran) return 0;
      return 1 - Math.min(eserOran, baskiOran) / Math.max(eserOran, baskiOran);
    },

    /*
      Uyarı eşiği: yüzde 18.

      Katalogdaki 9000 ürün x boyut birleşiminin dağılımından seçildi.
      Ortanca kayıp yüzde 6,8; yüzde 10 eşiği birleşimlerin yüzde 30,6'sında
      tetiklenirdi, bu da sıradan durumlarda çıkan ve bu yüzden okunmayan bir
      uyarı demek. Yüzde 18 birleşimlerin yüzde 4,1'inde (231 ürün)
      tetikleniyor. Sınır gözle de doğrulandı: yüzde 15'te kesilen yer
      eserin boş kenarı oluyor, yüzde 19'da konu kenara dayanıyor, yüzde
      20,6'da figürün ayakları kesiliyor. Yani eşik, kaybın konuya değmeye
      başladığı yer.
    */
    kirpmaEsigi: 0.18,

    kirpmaUyarisi(eserOran, baskiOran) {
      return this.kirpmaKaybi(eserOran, baskiOran) >= this.kirpmaEsigi;
    },
  };
})();
